import { awsConfigDev } from "./aws-config-dev";
import { awsConfigPreprod } from "./aws-config-preprod";
import { awsConfigProd } from "./aws-config-prod";

const getAwsConfig = () => {
  console.log("Current Environment:", process.env.NODE_ENV);
  console.log("App Environment:", process.env.VUE_APP_ENVIRONMENT);

  switch (process.env.VUE_APP_ENVIRONMENT) {
    case "development":
      return awsConfigDev;
    case "preprod":
      return awsConfigPreprod;
    case "production":
      return awsConfigProd;
    default:
      console.warn(
        "No environment specified, falling back to development config"
      );
      return awsConfigDev;
  }
};

export const awsConfig = getAwsConfig();
